import { useMemo } from "react";
import { Report } from "@/types/evaluate";
const useReportGroups = (reports: Report[] | undefined) => {
  return useMemo(() => {
    if (!reports) return {};

    return reports
      .filter((r) => r.parent_report_id)
      .reduce((groups: Record<string, Report[]>, report) => {
        const groupKey = report.parent_report_id?.toString() || "default";
        if (!groups[groupKey]) {
          groups[groupKey] = [];
        }
        groups[groupKey].push(report);
        return groups;
      }, {});
  }, [reports]);
};

export default useReportGroups;
